// automatically generated by the FlatBuffers compiler, do not modify

import * as flatbuffers from 'flatbuffers';

import { Visualization } from './visualization';


export class Mesh {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
__init(i:number, bb:flatbuffers.ByteBuffer):Mesh {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsMesh(bb:flatbuffers.ByteBuffer, obj?:Mesh):Mesh {
  return (obj || new Mesh()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsMesh(bb:flatbuffers.ByteBuffer, obj?:Mesh):Mesh {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new Mesh()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

guid():string|null
guid(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
guid(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

imageGuid():string|null
imageGuid(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
imageGuid(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

label():string|null
label(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
label(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 8);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

color():number {
  const offset = this.bb!.__offset(this.bb_pos, 10);
  return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
}

isVisible():boolean {
  const offset = this.bb!.__offset(this.bb_pos, 12);
  return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
}

visualization():Visualization {
  const offset = this.bb!.__offset(this.bb_pos, 14);
  return offset ? this.bb!.readUint8(this.bb_pos + offset) : Visualization.BasicColor;
}

static startMesh(builder:flatbuffers.Builder) {
  builder.startObject(6);
}

static addGuid(builder:flatbuffers.Builder, guidOffset:flatbuffers.Offset) {
  builder.addFieldOffset(0, guidOffset, 0);
}

static addImageGuid(builder:flatbuffers.Builder, imageGuidOffset:flatbuffers.Offset) {
  builder.addFieldOffset(1, imageGuidOffset, 0);
}

static addLabel(builder:flatbuffers.Builder, labelOffset:flatbuffers.Offset) {
  builder.addFieldOffset(2, labelOffset, 0);
}

static addColor(builder:flatbuffers.Builder, color:number) {
  builder.addFieldInt32(3, color, 0);
}

static addIsVisible(builder:flatbuffers.Builder, isVisible:boolean) {
  builder.addFieldInt8(4, +isVisible, +false);
}

static addVisualization(builder:flatbuffers.Builder, visualization:Visualization) {
  builder.addFieldInt8(5, visualization, Visualization.BasicColor);
}

static endMesh(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static createMesh(builder:flatbuffers.Builder, guidOffset:flatbuffers.Offset, imageGuidOffset:flatbuffers.Offset, labelOffset:flatbuffers.Offset, color:number, isVisible:boolean, visualization:Visualization):flatbuffers.Offset {
  Mesh.startMesh(builder);
  Mesh.addGuid(builder, guidOffset);
  Mesh.addImageGuid(builder, imageGuidOffset);
  Mesh.addLabel(builder, labelOffset);
  Mesh.addColor(builder, color);
  Mesh.addIsVisible(builder, isVisible);
  Mesh.addVisualization(builder, visualization);
  return Mesh.endMesh(builder);
}
}
